
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/table-sort-label",
      function () {
        return require("private-next-pages/material-ui/api/table-sort-label.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/table-sort-label"])
      });
    }
  